import { useState, useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext.tsx';
import { scheduledAppointmentsService } from '@/services/features/ScheduledAppointmentsService';

export const usePEClinicIds = () => {
  const { user, token } = useAuth();
  const [clinicIds, setClinicIds] = useState<number[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetchClinicIds();
  }, [user?.id, token]);

  const fetchClinicIds = async () => {
    if (!user?.id || !token) return;

    console.log('usePEClinicIds - fetchClinicIds called for user:', user.id);

    try {
      setIsLoading(true);
      setError(null);

      const ids = await scheduledAppointmentsService.fetchUserClinicIds(
        parseInt(user.id),
        token
      );

      console.log('usePEClinicIds - Fetched clinic IDs from REST API:', ids);
      setClinicIds(ids);
    } catch (err) {
      console.error('Error fetching clinic IDs:', err);
      setError(err instanceof Error ? err.message : 'Unknown error');
      setClinicIds([2]);
    } finally {
      setIsLoading(false);
    }
  };

  return { clinicIds, isLoading, error, refetch: fetchClinicIds };
};